export class ApplicationResourcesFormat {
    public static WEBP2_FORMAT_ENABLED: boolean = true
    public static MERGED_SPINE_ATLASES_ENABLED: boolean = false
    public static JP2_FORMAT_ENABLED: boolean = false
}
